import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppHeader from './components/AppHeader';
import Footer from './components/Footer';
import ScrollManager from './components/ScrollManager';
import SiteMetadata from './components/SiteMetadata';
import HomePage from './pages/HomePage';
import CompanyInfo from './pages/CompanyInfo';
import FAQPage from './pages/FAQpage';
import FAQPlus from './pages/FAQPlus';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import './index.css';

const App = () => (
  <div className="site-shell">
    <SiteMetadata />
    <a className="skip-link" href="#main-content">本文へスキップ</a>
    <ScrollManager />
    <AppHeader />
    <main id="main-content">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/company" element={<CompanyInfo />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/faqplus" element={<FAQPlus />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

export default App;
